define((require) => {
    "use strict";

    const Enum = require("shared/util/Enum");

    return Enum.create("LayerEnum", "value", {
        NA: {
            value: "NA",
            name: "North America"
        },
        EMEA: {
            value: "EMEA",
            name: "EMEA"
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/Scene7HostedRegionEnum.js